/*
import { Popper } from '../../../../../../node_modules/bootstrap/dist/js/bootstrap.esm'

import dselect from './dselect/source/js/dselect';

const selectElement = document.querySelectorAll('.selectpicker');

selectElement.forEach(function (select) {
  dselect(select);
});

*/

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.selectpicker').length) {
    import('./_bs-select.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}